import { Table } from 'reactstrap';

const tableHeaderStyle: React.CSSProperties = {
  width: '-10px',
  textAlign: 'center',
  color: '#f2f2f2',
  backgroundColor: 'rgb(96, 125, 145)',
  padding: '5px',
  fontWeight: 'bold',
  borderBottom: '1px solid #7a6362',
  borderTop: '1px solid #7a6362',
  borderLeft: '1px solid #7a6362',
  borderRight: '1px solid #7a6362',
};

const tableHeaderStyleIN: React.CSSProperties = {
  textAlign: 'center',
  color: '#f2f2f2',
  backgroundColor: 'rgb(96, 125, 145)',
  padding: '5px',
  width: '50%',
  fontWeight: 'bold',
  borderBottom: '1px solid #7a6362',
  borderTop: '1px solid #7a6362',
  borderLeft: '1px solid #7a6362',
  borderRight: '1px solid #7a6362',
};

const tableDataStyleA: React.CSSProperties = {
  textAlign: 'left',
  color: '#232323',
  backgroundColor: '#f2f2f2',
  padding: '10px',
  borderBottom: '1px solid #7a6362',
  borderTop: '1px solid #7a6362',
  borderLeft: '1px solid #7a6362',
  borderRight: '1px solid #7a6362',
};

// Action values that carry a plain descriptive string as JsonData (rendered as-is, no table).
const PLAIN_TEXT_ACTIONS = [
  'VIEW',
  'Regenrate',
  'REGENERATE',
  'DELETE',
  'DOWNLOAD',
  'DOWNLOAD OUTPUT',
  'DOWNLOAD PDF',
  'DOWNLOAD RAW',
  'VIEW COST',
];

export const renderJsonDataTable = (jsonData: any, action: string, Parentid: any) => {

  const renderProvidersTable = (providers: any[]) => (
    <table style={{ width: '100%' }}>
      <thead>
        <tr>
          <th className="audit-tableHeaderStyle">First Name</th>
          <th className="audit-tableHeaderStyle">Middle Name</th>
          <th className="audit-tableHeaderStyle">Last Name</th>
          <th className="audit-tableHeaderStyle">Provider ID</th>
        </tr>
      </thead>
      <tbody>
        {providers.map((provider: any) => (
          <tr key={provider.providerId}>
            <td className="audit-tableDataStyle">{provider.firstName}</td>
            <td className="audit-tableDataStyle">{provider.middleName}</td>
            <td className="audit-tableDataStyle">{provider.lastName}</td>
            <td className="audit-tableDataStyle">{provider.providerId}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  const renderInsuranceTable = (insuranceData: any[]) => (
    <table style={{ width: '100%' }}>
      <thead>
        <tr>
          <th className="audit-tableHeaderStyle">User Name</th>
          <th className="audit-tableHeaderStyle">Insurance</th>
          <th className="audit-tableHeaderStyle">Link</th>
          <th className="audit-tableHeaderStyle">Password</th>
        </tr>
      </thead>
      <tbody>
        {insuranceData.map((insurance: any) => (
          <tr key={insurance.insurance}>
            <td className="audit-tableDataStyle">{insurance.Username}</td>
            <td className="audit-tableDataStyle">{insurance.insurance}</td>
            <td className="audit-tableDataStyle">{insurance.link}</td>
            <td className="audit-tableDataStyle">********</td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  const renderGroupTable = (groupData: any[]) => (
    <table style={{ width: '100%' }}>
      <thead>
        <tr>
          <th className="audit-tableHeaderStyle">Provider ID</th>
        </tr>
      </thead>
      <tbody>
        {groupData.map((group: any) => (
          <tr key={group.providerId}>
            <td className="audit-tableDataStyle">{group.providerId}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  const renderKeyValueTable = (data: Record<string, any>) => (
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        <tr>
          <th className="audit-tableHeaderStyle">Key</th>
          <th className="audit-tableHeaderStyle">Value</th>
        </tr>
      </thead>
      <tbody>
        {Object.entries(data || {}).map(([key, value]) => (
          <tr key={key}>
            <td className="audit-tableDataStyle">{key}</td>
            <td className="audit-tableDataStyle">{value || "N/A"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  if (PLAIN_TEXT_ACTIONS.includes(action)) {
    return <div>{jsonData}</div>;
  }

  if (action === 'EDIT') {
    if (Array.isArray(jsonData)) {
      return (
        <Table bordered size="sm">
          <thead>
            <tr>
              <th style={tableHeaderStyle}>Field</th>
              <th style={tableHeaderStyle}>Before</th>
              <th style={tableHeaderStyle}>After</th>
            </tr>
          </thead>
          <tbody>
            {jsonData.map(
              (
                item: { field: string; value: any; before: string | any[]; after: string | any[] },
              ) => (
                <tr key={item.field}>
                  <td style={tableDataStyleA}>
                    <strong>{item.field}</strong>
                  </td>
                  <td style={tableDataStyleA}>
                    {item.field === 'Permission' && Array.isArray(item.before) ? (
                      <table style={{ width: '100%' }}>
                        <thead>
                          <tr>
                            <th className="audit-tableHeaderStyle">Menu</th>
                            <th className="audit-tableHeaderStyle">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {item.before.map((permission: any) => (
                            <tr key={permission.MenuLabel}>
                              <td className="audit-tableDataStyle">{permission.MenuLabel}</td>
                              <td className="audit-tableDataStyle">
                                {Array.isArray(permission.MenuActions) ? permission.MenuActions.join(', ') : permission.MenuActions}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : item.field === 'PayorUsernames' && Array.isArray(item.before) ? (
                      item.before.join(', ')
                    ) : item.field === 'Providers' && Array.isArray(item.before) ? (
                      renderProvidersTable(item.before)
                    ) : item.field === 'Insurance' && Array.isArray(item.before) ? (
                      renderInsuranceTable(item.before)
                    ) : item.field === 'Group' && Array.isArray(item.before) ? (
                      renderGroupTable(item.before)
                    ) : item.field === "Template format Edited Data" && typeof item.before === "object" ? (
                      renderKeyValueTable(item.before)
                    ) : (
                      item.before
                    )}
                  </td>
                  <td style={tableDataStyleA}>
                    {item.field === 'Permission' && Array.isArray(item.after) ? (
                      <table style={{ width: '100%' }}>
                        <thead>
                          <tr>
                            <th className="audit-tableHeaderStyle">Menu</th>
                            <th className="audit-tableHeaderStyle">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {item.after.map((permission: any) => (
                            <tr key={permission.MenuLabel}>
                              <td className="audit-tableDataStyle">{permission.MenuLabel}</td>
                              <td className="audit-tableDataStyle">
                                {Array.isArray(permission.MenuActions) ? permission.MenuActions.join(', ') : permission.MenuActions}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : item.field === 'PayorUsernames' && Array.isArray(item.after) ? (
                      item.after.join(', ')
                    ) : item.field === 'Providers' && Array.isArray(item.after) ? (
                      renderProvidersTable(item.after)
                    ) : item.field === 'Insurance' && Array.isArray(item.after) ? (
                      renderInsuranceTable(item.after)
                    ) : item.field === 'Group' && Array.isArray(item.after) ? (
                      renderGroupTable(item.after)
                    ) : item.field === "Template format Edited Data" && typeof item.after === "object" ? (
                      renderKeyValueTable(item.after)
                    ) : (
                      item.after
                    )}
                  </td>
                </tr>
              )
            )}
          </tbody>
        </Table>
      );
    } else if (jsonData && typeof jsonData === 'object') {
      return (
        <Table bordered size="sm">
          <thead>
            <tr>
              <th style={tableHeaderStyle}>Field</th>
              <th style={tableHeaderStyle}>Value</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(jsonData).map(([key, value]) => (
              <tr key={key}>
                <td style={tableDataStyleA}><strong>{key}</strong></td>
                <td style={tableDataStyleA}>
                  {Array.isArray(value) ? value.join(', ') : String(value)}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      );
    } else {
      return <div><center>No data available</center></div>;
    }
  }

  if (action === 'ADD') {
    if (Array.isArray(jsonData)) {
      return (
        <Table bordered size="sm">
          <thead>
            <tr>
              <th style={tableHeaderStyle}>Field</th>
              <th style={tableHeaderStyle}>Value</th>
            </tr>
          </thead>
          <tbody>
            {jsonData.map((item: { field: string; value: any }) => (
              <tr key={item.field}>
                <td style={tableDataStyleA}><strong>{item.field}</strong></td>
                <td className="audit-tableDataStyle">
                  {item.field === 'Permission' && Array.isArray(item.value) ? (
                    <table style={{ width: '100%' }}>
                      <thead>
                        <tr>
                          <th className="audit-tableHeaderStyle">Menu</th>
                          <th className="audit-tableHeaderStyle">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {item.value.map((permission: any) => (
                          <tr key={permission.MenuLabel}>
                            <td className="audit-tableDataStyle">{permission.MenuLabel}</td>
                            <td className="audit-tableDataStyle">{permission.MenuActions}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : item.field === 'PayorUsernames' && Array.isArray(item.value) ? (
                    item.value.join(', ')
                  ) : item.field === 'Password' || item.field === 'Pin' ? (
                    '******'
                  ) : item.field === 'Providers' && Array.isArray(item.value) ? (
                    renderProvidersTable(item.value)
                  ) : item.field === 'Insurance' && Array.isArray(item.value) ? (
                    renderInsuranceTable(item.value)
                  ) : item.field === 'Group' && Array.isArray(item.value) ? (
                    renderGroupTable(item.value)
                  ) : (
                    item.value && typeof item.value === 'object' ? (
                      Object.entries(item.value || {}).map(([key, val]) => (
                        <div key={key}>{`${key}: ${val}`}</div>
                      ))
                    ) : (
                      item.value
                    )
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      );
    } else {
      return <div><center>No data available</center></div>;
    }
  }
  if (action === 'bulk_upload') {
    if (!jsonData || typeof jsonData !== 'object') {
      return <div><center>No data available</center></div>;
    }

    // Convert object → array of {field, value}
    const dataArray = Object.entries(jsonData || {}).map(([key, value]) => ({
      field: key,
      value,
    }));

    return (
      <Table bordered size="sm">
        <thead>
          <tr>
            <th style={tableHeaderStyle}>Field</th>
            <th style={tableHeaderStyle}>Value</th>
          </tr>
        </thead>
        <tbody>
          {dataArray.map((item) => (
            <tr key={item.field}>
              <td style={tableDataStyleA}><strong>{item.field}</strong></td>
              <td style={tableDataStyleA}>{String(item.value)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }


  if (Array.isArray(jsonData)) {
    return (
      <Table bordered size="sm">
        <thead>
          <tr>
            <th style={tableHeaderStyleIN}>Field</th>
            <th style={tableHeaderStyleIN}>Value</th>
          </tr>
        </thead>
        <tbody>
          {jsonData.map((item: { field: string; value: any }) => (
            <tr key={item.field}>
              <td style={tableDataStyleA}><strong>{item.field}</strong></td>
              <td style={tableDataStyleA}>
                {item.field === 'Password' || item.field === 'pin' ? (
                  '******'
                ) : Array.isArray(item.value) ? (
                  item.value.map((val: any) => (
                    <div key={val}>{val}</div>
                  ))
                ) : item.field === 'Providers' && Array.isArray(item.value) ? (
                  renderProvidersTable(item.value)
                ) : item.field === 'Insurance' && Array.isArray(item.value) ? (
                  renderInsuranceTable(item.value)
                ) : item.field === 'Group' && Array.isArray(item.value) ? (
                  renderGroupTable(item.value)
                ) : (
                  item.value && typeof item.value === 'object' ? (
                    Object.entries(item.value).map(([key, val]) => (
                      <div key={key}>{`${key}: ${val}`}</div>
                    ))
                  ) : (
                    item.value
                  )
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  } else {
    return <div><center>No data available</center></div>;
  }
};
